import React, { useEffect } from 'react';
import { SpotlightCard } from './ui/spotlight-card';

export default function CalendarSection() {
  useEffect(() => {
    // Initialize Cal.com when component mounts
    if (window.Cal) {
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      const initialTheme = media.matches ? 'dark' : 'light';
      
      window.Cal.ns.calendar("inline", {
        elementOrSelector:"#my-cal-inline-calendar",
        config: {"layout":"month_view"},
        calLink: "edlukacs/calendar",
      });

      window.Cal.ns.calendar("ui", {"cssVarsPerTheme":{"light":{"cal-brand":"#3a3a3a"}},"hideEventTypeDetails":false,"layout":"month_view"});

      // Sync theme when system preference changes
      const handleThemeChange = (e) => {
        const theme = e.matches ? 'dark' : 'light';
        try {
          window.Cal.ns.calendar("ui", { theme });
        } catch {}
        // Keep Bootstrap-based theme attribute in sync
        document.documentElement.setAttribute('data-bs-theme', theme);
        try {
          localStorage.setItem('theme', theme);
        } catch {}
      };
      media.addEventListener?.('change', handleThemeChange);
      media.addListener && media.addListener(handleThemeChange); // Safari fallback

      return () => {
        media.removeEventListener?.('change', handleThemeChange);
        media.removeListener && media.removeListener(handleThemeChange);
      };
    }
  }, []);

  return (
    <SpotlightCard
      className="page-section"
      spotlightColor="rgba(99, 102, 241, 0.3)"
    >
      <div className="calendar-container" style={{ width: '100%' }}>
        <div style={{ width: '100%', height: '100%', overflow: 'scroll' }} id="my-cal-inline-calendar"></div>
      </div>
    </SpotlightCard>
  );
}
